import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CourseView from '@/views/CourseView.vue'
import ContactView from '@/views/ContactView.vue'
import BlogView from '@/views/BlogView.vue'
import TutorialsView from '@/views/TutorialsView.vue'

import IntroToComputer from '@/views/TutorialsPage/IntroToComputer.vue'
import MsOffice from '@/views/TutorialsPage/MsOffice.vue'
import InternetNetwork from '@/views/TutorialsPage/InternetNetwork.vue'
import DatabaseConcept from '@/views/TutorialsPage/DatabaseConcept.vue'
import ComputerProgramming from '@/views/TutorialsPage/ComputerProgramming.vue'
import WebTechnology from '@/views/TutorialsPage/WebTechnology.vue'
import GraphicDesign from '@/views/TutorialsPage/GraphicDesign.vue'
import CyberSecurity from '@/views/TutorialsPage/CyberSecurity.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

  {
    path: '/tutorials',
    name: 'tutorials',
    component: TutorialsView
  },



  { path: "/intro-to-computer", name: "IntroToComputer", component: IntroToComputer },
  { path: "/ms-office", name: "MSOffice", component: MsOffice },
  { path: "/internet-network", name: "InternetNetwork", component: InternetNetwork },
  { path: "/database-concept", name: "DatabaseConcept", component: DatabaseConcept },
  { path: "/Computer-programming", name: "ComputerProgramming", component: ComputerProgramming },
  { path: "/web-technology", name: "WebTechnology", component: WebTechnology },
  { path: "/graphic-design", name: "GraphicDesign", component: GraphicDesign },
  { path: "/cyber-security", name: "CyberSecurity", component: CyberSecurity },


  {
    path: '/courses',
    name: 'courses',
    component: CourseView
  },

  {
    path: '/blog',
    name: 'blog',
    component: BlogView
  },

  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },

  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
